const validator = {
  getMessage: field => `O campo ${field} não pode ser zero.`,
  validate: value => {
    let retorno = false
    retorno = value !== '0,00'
    return retorno
  }
}

export default validator
